import { useEffect } from "react";
import { MapContainer, TileLayer, Polyline, Marker, Tooltip, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const COLORS = { depart: "#0f172a", chargement: "#1559d6", livraison: "#0d9488" };

const pin = (n, kind) => L.divIcon({
  className: "",
  iconSize: [30, 30],
  iconAnchor: [15, 15],
  html: `<div style="width:30px;height:30px;border-radius:9999px;background:${COLORS[kind]};color:#fff;font-weight:700;font-size:13px;display:flex;align-items:center;justify-content:center;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.35)">${n}</div>`,
});

function Fit({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length) map.fitBounds(points, { padding: [30, 30], maxZoom: 14 });
  }, [map, points]);
  return null;
}

export const ItineraryMap = ({ stops, geometry }) => {
  const located = stops.map((s, i) => ({ ...s, n: i })).filter((s) => s.point);
  const bounds = geometry.length ? geometry : located.map((s) => s.point);
  return (
    <div data-testid="itinerary-map" className="relative z-0 h-72 overflow-hidden rounded-2xl border border-slate-200 sm:h-96">
      <MapContainer center={[46.6, 2.4]} zoom={6} className="h-full w-full" scrollWheelZoom={false}>
        <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {geometry.length > 0 && <Polyline positions={geometry} pathOptions={{ color: "#1559d6", weight: 5, opacity: 0.8 }} />}
        {located.map((s) => (
          <Marker key={s.n} position={s.point} icon={pin(s.kind === "depart" ? "D" : s.n + (stops[0].kind === "depart" ? 0 : 1), s.kind)}>
            <Tooltip>{s.label}</Tooltip>
          </Marker>
        ))}
        <Fit points={bounds} />
      </MapContainer>
    </div>
  );
};
